import Logo from "@/components/Logo";
const legal = [
  ["Terms & Conditions", "/legal#terms"],
  ["Privacy Policy", "/legal#privacy"],
  ["Refund Policy", "/legal#refunds"],
  ["Risk Warning", "/legal#risk"],
  ["AI Disclaimer", "/legal#ai"],
  ["Community Guidelines", "/legal#aup"],
];
const socials = [
  ["Instagram", "https://instagram.com/mbm.tradingau"],
];

export default function Footer() {
  return (
    <footer
      className="relative border-t border-white/10 py-16"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <Logo className="h-9 w-auto" />
            <p className="mt-4 text-sm text-zinc-500 font-light leading-relaxed">
              Mind Before Markets. Trading psychology & mentorship.
              <br />
              Melbourne, Australia.
            </p>
          </div>

          <div className="flex gap-16">
            <div>
              <div className="section-label text-[10px] text-zinc-600">
                Connect
              </div>
              <ul className="mt-5 space-y-3">
                {socials.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-zinc-400 hover:text-white transition-colors font-light"
                      data-testid={`footer-social-${label}`}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="section-label text-[10px] text-zinc-600">
                Legal
              </div>
              <ul className="mt-5 space-y-3">
                {legal.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      className="text-sm text-zinc-400 hover:text-white transition-colors font-light"
                      data-testid={`footer-legal-${label}`}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-xs text-zinc-600 font-light leading-relaxed max-w-3xl">
            <span className="text-zinc-500">Disclaimer:</span> All content and
            tools provided by Mind Before Markets are for educational purposes
            and analysis or decision support only, and do not constitute
            financial, investment or trading advice. Nothing here is a buy or
            sell recommendation. Trading futures, forex and cryptocurrencies
            involves substantial risk of loss and is not suitable for every
            investor. Past performance is not indicative of future results. No
            profit or income is guaranteed.
          </p>
          <p className="mt-6 text-xs text-zinc-700 font-mono">
            © {new Date().getFullYear()} Mind Before Markets · ABN 65 440 168 907 · Melbourne, AU.
          </p>
        </div>
      </div>
    </footer>
  );
}
